import { makeStyles } from '@material-ui/core';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
const styles = makeStyles(theme => ({
    bannerContainer: props => ({
        maxWidth: '1017px',
        margin: '0 auto',
        borderRadius: '0.625rem',
        height: 'auto',
        padding: '0rem',
        [theme.breakpoints.down('sm')]: {
            boxShadow: theme?.palette?.boxShadow,
            background: `url(${props?.bannerMobile}) no-repeat center/cover`,
            backgroundColor: theme?.palette?.backgroundColor,
        },
        [theme.breakpoints.up('sm')]: {
            background: `url(${props?.bannerTablet}) right/cover no-repeat`,
            backgroundColor: theme?.palette?.backgroundColor,
        },
        [theme.breakpoints.up('md')]: {
            background: `url(${props?.bannerDesktop}) 100% 100%/cover no-repeat `,
            backgroundColor: theme?.palette?.backgroundColor,
        },
    }),
    bannerDetails: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
    },
    bannerBoxContainer: {
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
        },
    },
    headerBackArrow: {
        cursor: 'pointer',
        height: '1.375rem',
        width: '1.375rem',
        margin: '1.5rem 0 0 1rem',
    },
    bannerBox: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        paddingLeft: '3.5rem',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            padding: 0,
        },
        [theme.breakpoints.between('sm', 'md')]: {
            pl: '2.5rem',
        },
    },
    bannerTitle: {
        color: theme?.palette?.textHeading,
        letterSpacing: 'inherit',
        paddingTop: '1rem',
    },
    bannerDescription: {
        paddingTop: '1rem',
        color: theme?.palette?.textBody,
        letterSpacing: 'inherit',
        [theme.breakpoints.down('sm')]: {
            padding: '1.5rem 1rem 1.3rem 1rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            padding: '1.5rem 4rem 1.3rem 4rem',
        },
        [theme.breakpoints.up('md')]: {
            padding: '2rem 1.3rem 1.5rem 0rem',
        },
    },
    bannerCTA: {
        padding: '1.5rem 0',
        [theme.breakpoints.down('sm')]: {
            padding: '2rem 3rem 1.5rem 3rem',
        },
    },
}));

export default styles;
